import { render, staticRenderFns } from "./paset.vue?vue&type=template&id=1e4a6ba0&"
import script from "./paset.vue?vue&type=script&lang=js&"
export * from "./paset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports